import React, { useEffect, useRef, useState } from "react";

import "./SelectField.css";

type SelectFieldProps = {
  label: string;
  name: string;
  value: { label: string; value: string };
  onChange: (e: { label: string; value: string }) => void;
  options: { label: string; value: string }[];
  error?: string;
  required?: boolean;
};

const SelectField: React.FC<SelectFieldProps> = ({
  label,
  name,
  value,
  onChange,
  options,
  error,
  required = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const selectRef = useRef<HTMLDivElement>(null);
  const toggleDropdown = () => setIsOpen(!isOpen);

  const handleOptionClick = (val: { label: string; value: string }) => {
    onChange(val);
    // onChange({ name, value: val });
    setIsOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        selectRef.current &&
        !selectRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="select-field">
      <label>
        {label} {required && <span className="text-red">*</span>}
      </label>
      <div
        className="select-container"
        onClick={toggleDropdown}
        ref={selectRef}
      >
        <div className={`custom-select ${error ? "border-red" : ""}`}>
          <span>{value?.label || "-- Select --"}</span>
          <span className="select-arrow">&#9662;</span> {/* ▼ */}
        </div>
        {isOpen && (
          <div className="custom-options">
            {options.map((option) => (
              <div
                key={option.value}
                className="custom-option"
                onClick={() => handleOptionClick(option)}
              >
                {option.label}
              </div>
            ))}
          </div>
        )}
        <span className="select-arrow">&#9662;</span>
      </div>
    </div>
  );
};

export default SelectField;
